import React, { MouseEventHandler, useEffect, useState } from 'react';
import { SVGIcon } from '../../../components/atoms/SVG';
import { BtnModifier } from '../../../components/molecules/Btn';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Button } from '../../../components/molecules/Btn/Button';
import { LinkProps } from '../../../types/HtmlProps';
import { Anchor } from '../../../components/molecules/Btn/Button/Anchor';

type BlockBarAnchorProps = LinkProps & {
  onClick: MouseEventHandler<HTMLAnchorElement>;
  text: string;
  svgSpriteId: SVGIcon;
  ref?: React.RefObject<HTMLAnchorElement | null>;
};

export function BlockBarAnchor({ onClick, text, svgSpriteId, ref, ...props }: BlockBarAnchorProps) {
  return (
    <div className="block-bar__button">
      <Anchor
        ref={ref}
        onClick={onClick}
        tooltipPlacement={TooltipPlacement.TOP}
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
        title={text}
        hideTooltipFromScreenReader
        {...props}
      >
        <Button.Icon svgSpriteId={svgSpriteId} text={text} />
      </Anchor>
    </div>
  );
}

export const useBlockBarCreateHref = (
  currentActiveView: string | undefined,
  viewHrefMap: Record<string, string | undefined | null>,
  id: string,
) => {
  const [currentActiveViewHref, setCurrentActiveViewHref] = useState(
    `${currentActiveView ? viewHrefMap[currentActiveView] : null}#${id}`,
  );

  useEffect(() => {
    setCurrentActiveViewHref(`${currentActiveView ? viewHrefMap[currentActiveView] : null}#${id}`);
  }, [currentActiveView, id, viewHrefMap]);

  return currentActiveViewHref;
};
